import React, { useState } from 'react'
import { InputNumber } from 'primereact/inputnumber'
import { isNonEligibleContributionType, isNonEligibleContributor } from 'modules/Constants'

const MAX_MINUTES_ABSOLUTE = 1000

const MinutesEditor = ({ options, validationErrors, episodeDuration, editorCallbacksRef, toastRef, dataKey }) => {
    const rowIndex = options.rowIndex
    const rowData = options.rowData
    const rowKey = rowData[dataKey]
    const [isInvalid, setIsInvalid] = useState(false)
    const [currentContributionType, setCurrentContributionType] = useState(rowData.contributionType)

    const maxMinutes = episodeDuration > 0 ? Math.min(MAX_MINUTES_ABSOLUTE, episodeDuration) : MAX_MINUTES_ABSOLUTE
    // Read-only if contribution type is Actor or Director (regardless of contact type)
    const isReadonly = isNonEligibleContributionType(currentContributionType)

    // Register callbacks keyed by row to support multiple rows editing simultaneously
    if (editorCallbacksRef?.current) {
        if (!editorCallbacksRef.current.minutes) editorCallbacksRef.current.minutes = {}
        if (!editorCallbacksRef.current.setMinutesContributionType) editorCallbacksRef.current.setMinutesContributionType = {}
        editorCallbacksRef.current.minutes[rowKey] = options.editorCallback
        editorCallbacksRef.current.setMinutesContributionType[rowKey] = setCurrentContributionType
    }

    const handleValueChange = (e) => {
        if (isReadonly) return

        const value = e.value

        rowData.minutes = value
        options.editorCallback(value)

        if (value !== null && value > maxMinutes) {
            setIsInvalid(true)
            const errorMessage = episodeDuration > 0 && episodeDuration < MAX_MINUTES_ABSOLUTE
                ? `Minutes cannot be greater than episode duration (${episodeDuration} min)`
                : `Minutes cannot be greater than ${MAX_MINUTES_ABSOLUTE}`
            toastRef?.current?.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: errorMessage,
                life: 3000
            })
            return
        }

        setIsInvalid(false)

        if (episodeDuration > 0 && value !== null && value !== undefined) {
            const calculatedPercentage = (value / episodeDuration) * 100
            const roundedPercentage = Math.round(calculatedPercentage * 100) / 100

            rowData.percentage = roundedPercentage

            if (editorCallbacksRef?.current?.percentage?.[rowKey]) {
                editorCallbacksRef.current.percentage[rowKey](roundedPercentage)
            }
        }
    }

    const hasValidationError = (validationErrors[rowIndex] && validationErrors[rowIndex][options.field]) || isInvalid

    return (
        <InputNumber
            value={options.value}
            onValueChange={handleValueChange}
            className={hasValidationError ? 'p-invalid' : ''}
            useGrouping={false}
            min={0}
            minFractionDigits={2}
            maxFractionDigits={2}
            disabled={isReadonly}
        />
    )
}

export default MinutesEditor
